import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';

export type CertificateType = 'course' | 'certification' | 'learning_path';

export type RegenerationReason =
  | 'NAME_CHANGE'
  | 'TEMPLATE_UPDATE'
  | 'DATA_CORRECTION'
  | 'ADMIN_REQUESTED';

export interface RegenerationResponse {
  success: boolean;
  data: {
    id: string;
    certificate_number: string;
    holder_name: string;
    pdf_url: string;
    verification_url: string;
    issued_date: string;
    [key: string]: unknown;
  };
}

class CertificateRegenerationService {
  /**
   * Admin: Regenerate a certificate with a reason
   */
  async adminRegenerate(
    certificateId: string,
    type: CertificateType,
    reason: RegenerationReason
  ): Promise<RegenerationResponse> {
    const endpointMap = {
      certification: API_ENDPOINTS.CERTIFICATE_REGENERATION.ADMIN_CERTIFICATION,
      course: API_ENDPOINTS.CERTIFICATE_REGENERATION.ADMIN_COURSE,
      learning_path: API_ENDPOINTS.CERTIFICATE_REGENERATION.ADMIN_LEARNING_PATH,
    };

    const response = await apiClient.post(endpointMap[type](certificateId), { reason });
    return response.data;
  }

  /**
   * Learner: Regenerate own certificate (reason auto-set to USER_REQUESTED)
   */
  async learnerRegenerate(
    certificateId: string,
    type: CertificateType
  ): Promise<RegenerationResponse> {
    const endpointMap = {
      certification: API_ENDPOINTS.CERTIFICATE_REGENERATION.LEARNER_CERTIFICATION,
      course: API_ENDPOINTS.CERTIFICATE_REGENERATION.LEARNER_COURSE,
      learning_path: API_ENDPOINTS.CERTIFICATE_REGENERATION.LEARNER_LEARNING_PATH,
    };

    const response = await apiClient.post(endpointMap[type](certificateId));
    return response.data;
  }
}

export const certificateRegenerationService = new CertificateRegenerationService();
